import DecryptUnlockedPage from "./DecryptUnlockedPage";

export default DecryptUnlockedPage;
